<template>
  <div class="sub-manager">
    <!-- 下载三张尺寸的二维码 -->
    <canvas v-show="false" class="canvasQr" width="227" height="227"  ></canvas>
    <canvas v-show="false" class="canvasQr" width="425" height="425"  ></canvas>
    <canvas v-show="false" class="canvasQr" width="850" height="850"  ></canvas>

    <div class="white-box sub-manager-search column-content">
      <span class="sub-id-txt span-14">子站编号</span>
      <el-input @keyup.enter.native="subsiteListSearch()"  class="search-input" placeholder="请输入子站编号" v-model="subSiteId"></el-input>
      <span class="sub-name-txt span-14">子站名称</span>
      <el-input @keyup.enter.native="subsiteListSearch()"  class="search-input" placeholder="请输入子站名称" v-model="subSiteName"></el-input>
      <el-button :loading="loading" @click="subsiteListSearch()" type="primary" icon="search">搜索</el-button>
      <!-- <el-button>取消</el-button> -->
    </div>

    <div class="white-box sub-list">
      <p class="title">子站列表</p>
      <el-table
        :data="listData.list"
        style="width: 100%">
        <el-table-column
          prop="subSiteId"
          label="子站编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="subSiteName"
          label="子站名称"
          width="150">
        </el-table-column>
        <el-table-column
          label="链接" width="160">
          <template slot-scope="scope">
            <a class="sub-url" :href="scope.row.subsiteRealUrl">此链接为{{ scope.row.promotor.name }}的销售链接</a>
          </template>
        </el-table-column>
        <el-table-column label="子站二维码" width="120">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="left">
              <div class="preQr">
                <p>{{ `${scope.row.subSiteName}（子站二维码）` }}</p>
                <img :src="scope.row.subsiteRealQrcode" />
                <p>可使用手机扫码，查看子站在手机上的展示效果</p>
              </div>
              <div slot="reference" class="name-wrapper column-content qr-wrapper">
                <img class="qrImg" :src="scope.row.subsiteRealQrcode" />
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="注册二维码" width="120" label-class-name="codeTip">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="left">
              <div class="preQr">
                <p>{{ `${scope.row.subSiteName}（注册二维码）` }}</p>
                <img :src="scope.row.subsiteSigninQrCode" />
                <p>可使用手机扫码，查看子站在手机上的展示效果</p>
              </div>
              <div slot="reference" class="name-wrapper column-content qr-wrapper">
                <img class="qrImg" :src="scope.row.subsiteSigninQrCode" />
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间" width="169">
          <template slot-scope="scope">
            <div>{{getFormatTime(scope.row.createAt)}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="handle"
          label="操作"
          width="185">
          <template slot-scope="scope">
            <div class="operate-button">
              <p v-if="promotorType===1 && accountState===1" class="modifySub">
                <router-link :to="{name:'substationSet', query:{sid:scope.row.subSiteId}}"><el-button type="text" size="small">修改设置</el-button></router-link>
                <el-button type="text" size="small" @click="changeName(scope.row.subSiteId, scope.$index)">修改名称</el-button>
              </p>
              <p>
                <el-button class="copy-url" type="text" size="small" v-clipboard:copy="`${scope.row.subsiteRealUrl}`" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</el-button>
                <el-button type="text" size="small" @click="downloadQr(scope.row.subsiteRealQrcode, scope.row.subSiteName)">保存子站二维码</el-button>
              </p>
              <p>
                <el-button type="text" size="small" @click="downloadQr(scope.row.subsiteSigninQrCode, scope.row.subSiteName+'(注册)')">保存注册二维码</el-button>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listData.curPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="listData.totalRecords">
      </el-pagination>
      <canvas id="canvas"></canvas>
    </div>
    <p class="oTip">用户扫描本二维码后，会直接进入登录页面。用户通过本链接成为新注册用户，该用户将会被您锁定。</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {deleteEmptyObj, getFormatTime} from 'utils'
import { subsiteList, changeSubsiteName } from 'api'
  export default {
    data(){
      return {
        activeName: 'first',
        loading: false,
        subSiteId: '',
        subSiteName:'',
        pageSize:20,
        listData:{
          list:[],
          curPage:1,
          totalRecords: 0,
        },
        getFormatTime:getFormatTime
      }
    },
    computed: {
      ...mapGetters([
        'HOST',
        'PROTOCOL',
        'promotorType',
        'accountState'
      ])
    },
    created(){
      this.subsiteListSearch()
      this.downloadQr()
      this.$nextTick(() => this.addTips());
    },
    methods:{
      handleSizeChange(){
        this.pageSize = arguments[0]
        this.subsiteListSearch(1)
      },
      handleCurrentChange(){
        this.listData.curPage = arguments[0]
        this.subsiteListSearch(1)
      },
      subsiteListSearch(bringPag){
        let vis = this
        const temp = {
           "subSiteId": vis.subSiteId,      //子站编号  optional 与 子站名称 二选一，同时传以编号为准
           "subSiteName": vis.subSiteName,   //子站名称  optional 与 子站编号 二选一，同时传将被忽略
        }
        if(!/^[0-9]*[1-9][0-9]*$/.test(vis.subSiteId) && vis.subSiteId){
          vis.$message({
            type:'warning',
            message:'子站编号只能为正整数，请重新输入'
          })
          return
        }
        if(bringPag){
          temp['curPage'] = vis.listData.curPage
          temp['pageSize'] = vis.pageSize
        }
        vis.loading = true
        subsiteList(deleteEmptyObj(temp)).then(res=>{
          vis.loading = false
          if(res.ret ==0){
            vis.listData = res.data
          }
        }).catch(()=>{})
      },
      changeName(subSiteId, index){
        let vis = this
        this.$prompt('请输入子站名字', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          changeSubsiteName({subSiteId, subSiteName:value}).then(res=>{
            if(res.ret==0){
              this.$message({
                type: 'success',
                message: '修改成功'
              });
              vis.listData.list[index].subSiteName = value
            }
          }).catch(()=>{})
        }).catch(() => {
        });
      },
      drawBeauty(beauty){
        let mycv = document.getElementsByClassName("canvasQr")
        for(let i=0,len=mycv.length; i<len; i++){
          let child = mycv[i]
          const width = child.width
          let myctx = child.getContext("2d");
          myctx.drawImage(beauty, 0, 0, width, width);
        }
      },
      GetUrlRelativePath(url){
        var arrUrl = url.split("//");
        var start = arrUrl[1].indexOf("/");
        var relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符
        if(relUrl.indexOf("?") != -1){
          relUrl = relUrl.split("?")[0];
        }
        return relUrl;
      },
      downloadQr(qrUrl, subName){
        let vis = this
        if(qrUrl){
          new Promise(function(resolve, reject){
            let beauty = new Image()
            beauty.setAttribute('crossOrigin', 'anonymous')
            let relativePath
            try{
              relativePath = vis.GetUrlRelativePath(qrUrl)
            }catch(err){
               reject('二维码地址有误')
            }

            console.log(relativePath)
            beauty.src = vis.PROTOCOL+vis.HOST+'/qrcode'+relativePath
            if(beauty.complete){
               vis.drawBeauty(beauty);
               resolve()
            }else{
               beauty.onload = function(){
                 vis.drawBeauty(beauty);
                 resolve()
               };
               beauty.onerror = function(error){
                console.log(error)
                reject('图片加载失败，请重试')
               };
            }
          }).then(function(value){
            let type ='png'
            let fixtype=function(type){
                type=type.toLocaleLowerCase().replace(/jpg/i,'jpeg');
                let r=type.match(/png|jpeg|bmp|gif/)[0];
                return 'image/'+r;
            }
            let savaFile=function(data,filename)
            {
                let save_link=document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
                save_link.href=data;
                save_link.download=filename;
                let event=document.createEvent('MouseEvents');
                event.initMouseEvent('click',true,false,window,0,0,0,0,0,false,false,false,false,0,null);
                save_link.dispatchEvent(event);
            }

            let d=document.getElementsByClassName("canvasQr");
            for(let i=0,len=d.length; i<len; i++){
              let child = d[i]
              let imgdata=child.toDataURL(type);
              imgdata=imgdata.replace(fixtype(type),'image/octet-stream');
              const w = child.width
              const filename=`【${subName}】二维码 - ${w}x${w}.png`
              //我想用当前秒是可以解决重名的问题了 不行你就换成毫秒
              savaFile(imgdata,filename);
            }
          }).catch( error => {
            console.log(error)
            vis.$message({
              message: error,
              type: 'error'
            });
          })
        }
      },
      onCopy: function () {
        //console.log('copy')
        this.$message({
          message: '链接复制成功',
          type: 'success'
        });
      },
      addTips() {
        let oTarget = document.querySelector('.cell.codeTip');
        // tipIcon
        let oHelp = document.createElement('div');
        oHelp.innerHTML = '?';
        oHelp.style.cssText = 'position:absolute;top:50%;right:14px;transform:translateY(-50%);display:flex;justify-content:center;align-items:center;font-size:12px;color:#fff;width:15px;height:15px;border-radius:50%;background-color:#1f2d3d;cursor:pointer';
        oTarget.appendChild(oHelp);

        let oTip = document.querySelector('.oTip');
        let hoverFn = function (e) {
          let { clientX, clientY } = e;
          oTip.style.display = 'block';
          oTip.style.top = (clientY - 130) + 'px';
          oTip.style.left = (clientX - 135) + 'px';
        }
        let outFn = function () {
          oTip.style.display = 'none';
          oTip.style.top = 0;
          oTip.style.left = 0;
        }
        oHelp.onmouseover = hoverFn;
        oHelp.onmousemove = hoverFn;
        oHelp.onmouseout = outFn;
      },
      onError: function (e) {
        alert('Failed to copy texts')
      }
    }
  }
</script>

<style lang="scss" scoped>
.qr-wrapper{
  // height: 100px;
  //padding:15px 0;
  width: 65px;
  margin-top: 15px;
  margin-bottom: 15px;
  .qrImg{
    width: 65px;
    height: 65px;
  }
}
.preQr{
  width: 300px;
  height: 255px;
  text-align: center;
  img{
    width: 160px;
    height: 160px;
  }
}
.sub-manager{
  &>div.white-box{
    width: 1000px;
  }
}
.sub-manager-search{
  padding:20px 0px;
  .sub-id-txt{
    margin-left: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .sub-name-txt{
    margin-left: 30px;
    margin-right: 10px;
    vertical-align: middle;
  }
}
.sub-list{
  margin-top: 10px;
  height: auto;
  .title{
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    padding-left: 20px;
  }
  .operate-button{
    font-size: 12px;
    .modifySub>.el-button{
      margin-left: 10px;
    }
  }
  .sub-url{
    text-decoration: underline;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #4990E2;
  }
}
.oTip{
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  padding: 8px;
  font-size: 14px;
  color: #333;
  width: 165px;
  color: #fff;
  background-color: #1f2d3d;
  border-radius: 5px;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// subManager.vue?2668b6bc